var amdi18n={"__root":{"close":"Close"},"__cs":{"close":"Zavřít"},"__da":{"close":"Luk"},"__de":{"close":"Schließen"},"__es":{"close":"Cerrar"},"__fi":{"close":"Sulje"},"__fr":{"close":"Fermer"},"__hr":{"close":"Zatvori"},"__hu":{"close":"Bezárás"},"__it":{"close":"Chiudi"},"__ja":{"close":"閉じる"},"__kk":{"close":"Жабу"},"__ko":{"close":"닫기"},"__nb":{"close":"Lukk"},"__nl":{"close":"Sluiten"},"__no":{"close":"Lukk"},"__pl":{"close":"Zamknij"},"__pt":{"close":"Fechar"},"__pt-br":{"close":"Fechar"},"__ro":{"close":"Închidere"},"__ru":{"close":"Закрыть"},"__sl":{"close":"Zapri"},"__sv":{"close":"Stäng"},"__th":{"close":"ปิด"},"__tr":{"close":"Kapat"},"__zh":{"close":"关闭"},"__zh-cn":{"close":"关闭"},"__zh-hk":{"close":"關閉"},"__zh-mo":{"close":"關閉"},"__zh-sg":{"close":"关闭"},"__zh-tw":{"close":"關閉"}};amdi18n.init=function (language){
		// get the default language
		if(!language){
			if(window._i18n && window._i18n.locale){
				language = window._i18n.locale;
			}else if(document.documentElement.lang){
				language = document.documentElement.lang;
			}else{
				language = 'root';
			}
		}
		var target = this['__' + language] || this.__root;

		// copy definition to root level
		if (target) {
			for (var name in target) {
				this[name] = target[name];
			}
		}

		// fallback to root
		for(var name in this.__root){
			if(typeof this[name] === 'undefined'){
				this[name] = this.__root[name];
			}
		}
	};amdi18n.init();module.exports=amdi18n;